import { useLocale } from '@va/localization';
import { TooltipWrapper } from '@va/ui/tooltips';
import { Flag } from '@va/util/components';
import { getCountryCodeByLocale } from '@va/util/helpers';
import classNames from 'classnames';
import { useCallback, useState } from 'react';
import LanguageSelector from './languageSelector/LanguageSelector';

export const SmallLanguageSelector = ({
  className = 'z-[var(--zIndex-layout)] absolute left-0 md:left-4 bottom-0 ml-4 sm:mb-4 mb-3 cursor-pointer',
  buttonClassName,
}: {
  className?: string;
  buttonClassName?: string;
}) => {
  const [langSelectorVisible, setLangSelectorVisibility] = useState(false);
  const { locale } = useLocale();

  const closeLanguageSelector = useCallback(() => {
    setLangSelectorVisibility(false);
  }, []);

  return (
    <TooltipWrapper
      arrow={false}
      open={langSelectorVisible}
      tooltipClassNames='rounded-24 shadow-md'
      onOpenChange={(open) => setLangSelectorVisibility(open)}
      content={
        <div className='mb-2 min-w-full md:min-w-[25rem] h-400px rounded-24 bg-white border-2 border-gray-mercury text-black px-3 shadow-md py-3'>
          <LanguageSelector onLanguageSelected={closeLanguageSelector} languageListWrapperClassName='!max-h-[15rem]' />
        </div>
      }
      trigger='click'
      useDefaultStyle={false}
    >
      <div className={className} onClick={() => setLangSelectorVisibility(!langSelectorVisible)}>
        <div
          className={classNames(
            'flex justify-center items-center align-center bg-white h-14 w-14 rounded-12 border-2 border-solid border-gray-gallery',
            buttonClassName,
          )}
        >
          <div className='flex align-center items-center justify-center selected-language-flag rounded-[150%]'>
            <Flag
              size='1x1'
              countryCode={getCountryCodeByLocale(locale)}
              className='icon top-bar-icon rounded-full h-6 w-6'
              useEnglishLanguageFlag
            />
          </div>
        </div>
      </div>
    </TooltipWrapper>
  );
};
